<template>
  
 
            <div class="page-content">
                  

                  <nav class="page-breadcrumb" id="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item">{{breadcrumbA}}</li>
                      <li class="breadcrumb-item active" aria-current="page">{{breadcrumbB}}</li>
                    </ol>
                  </nav>

                  <div class="row">
                    <div class="col-md-12 grid-margin stretch-card">
                      <div class="card">
                        <div class="card-body">
                          <h6 class="card-title">{{breadcrumbB}}</h6>
                          <p class="card-description">
                           {{descripcion}}</p>



                            <div class="alert alert-danger" role="alert" id="sinreg">
                              NO EXISTEN REGISTROS GUARDADOS! PUEDE GUARDAR REGISTROS EN EL MODULO "AUTORIZADOS AGRUPADOS" DENTRO DE PROYECCIÒN BASICO
                            </div>
                                        
                    <div class="row ocultar">

                                <div class="col-md-4">
                                                            <select id="liquidacion-a"></select>

                            </div>

    


                             <div class="col-md-6">
                                 
                                  <button class="btn btn-primary mr-2 mb-2 mb-md-0 text-white" v-on:click="comparar()">PROYECTAR</button>
                             </div>


                            </div>
<!--
                            <br><br>
                            
                            <table class="table ocultar" width="100%">
                             
                                  <tr>
                                      <td colspan="2" style="background-color:#d6daad;" class="fecha1">Diciembre 2021</td>
                                      <td colspan="2" style="background-color:#e2b79d;" class="">Proyecciòn</td>
                                      <td  style="background-color:#ea9460;">Observacion</td>
                                  </tr>  

                                  <tr>
                                      <td style="background-color:#d6daad;">Personal</td>
                                      <td style="background-color:#d6daad;">Costo total</td>

                                      <td style="background-color:#e2b79d;">Personal</td>
                                      <td style="background-color:#e2b79d;">Costo total</td>

                                      <td style="background-color:#ea9460;">Diferencia</td>
                                  </tr>  

                                    <tr>
                                      <td style="background-color:#d6daad;" id="personal_a">0</td>
                                      <td style="background-color:#d6daad;" id="total_a">$0</td>

                                      <td style="background-color:#e2b79d;"><span id="personal_b">0</span>  <span id="porc_per_a"></span></td>
                                      <td style="background-color:#e2b79d;"><span id="total_b">$0</span> <span id="porc_cos_a"></span></td>

                                      <td style="background-color:#ea9460;"><span id="diferencia_t">$0</span> <span id="porc_dif"></span></td>
                                  </tr> 

                            </table>

                        -->


                        </div>  
                      </div>


                    </div>
                  </div>    



                  <div class="row">
          <div class="col-md-12 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                
<div class="row align-items-center">
  <div class="col-md-6 mb-2 mb-md-0">
    <button id="guardar" style="width:275px;margin-left:30px;display: none;" class="btn btn-danger mr-2 mb-2 mb-md-0 text-white" v-on:click="guardar()">PUBLICAR AUMENTOS SALARIALES</button>
  </div>
  <div class="col-md-6 text-md-right">
    <button
      v-if="proyeccionTable"
      type="button"
      class="btn btn-success mr-2 mb-2 mb-md-0 text-white"
      v-on:click="descargarExcelProyeccion()"
    >DESCARGAR EXCEL</button>
    <button v-if="mostrarBotonAjustes" class="btn btn-warning mr-2 mb-2 mb-md-0 text-white" v-on:click="toggleAjustes()">AJUSTES</button>
  </div>
</div>

<div class="col-md-12 mt-3" v-if="mostrarAjustes">
  <div class="card card-ajustes">
    <div class="card-body">
      <div class="d-md-flex justify-content-between align-items-center mb-3">
        <div>
          <h6 class="card-title mb-1">AJUSTES MANUALES</h6>
          <p class="card-description mb-0">Buscá por legajo, DNI o apellido, agregá la persona, escribí el porcentaje y publicá sólo esos ajustes en Firebase.</p>
        </div>
        <div class="mt-2 mt-md-0">
          <span class="badge badge-light badge-ajuste-liquidacion">Liquidación: {{ liquidacionAjustesTexto || 'Sin seleccionar' }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="font-weight-bold d-block mb-2">Publicación activa</label>
          <div class="alert alert-light border mb-2" v-if="ultimaPublicacionAjustes">
            <div><strong>Última publicación:</strong> {{ ultimaPublicacionAjustes.nombre }}</div>
            <div class="small text-muted mt-1">
              {{ ultimaPublicacionAjustes.timestamp || ultimaPublicacionAjustes.fecha || 'Sin fecha' }}
              <span v-if="ultimaPublicacionAjustes.creador_name"> · {{ ultimaPublicacionAjustes.creador_name }}</span>
              <span> · {{ ultimaPublicacionAjustes.cantidad }} persona(s)</span>
            </div>
          </div>
          <div class="alert alert-light border mb-2" v-else>
            No hay publicaciones previas para esta liquidación. Creá una nueva para empezar.
          </div>

          <div class="d-flex flex-wrap align-items-center gap-8 mb-2">
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm mr-2 mb-2"
              v-on:click="usarUltimaPublicacionAjustes()"
              :disabled="!ajustesPublicaciones.length"
            >USAR ÚLTIMA PUBLICACIÓN</button>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm mb-2"
              v-on:click="activarNuevaPublicacionAjustes()"
            >CREAR NUEVA PUBLICACIÓN</button>
          </div>

          <div v-if="ajustesPublicaciones.length && !ajustesModoNuevaPublicacion">
            <input
              type="text"
              class="form-control mb-2"
              v-model.trim="ajustesBusquedaPublicacion"
              placeholder="Buscar una publicación ya creada"
            >
            <select class="form-control" v-model="ajustesPublicacionSeleccionadaId" @change="sincronizarPublicacionSeleccionada()">
              <option value="">Seleccioná una publicación</option>
              <option
                v-for="publicacion in publicacionesAjustesFiltradas()"
                :key="'publicacion-ajuste-' + publicacion.id"
                :value="publicacion.id"
              >
                {{ publicacion.nombre }} · {{ publicacion.timestamp || publicacion.fecha || 'Sin fecha' }} · {{ publicacion.cantidad }} persona(s)
              </option>
            </select>
            <small class="text-muted d-block mt-2" v-if="ajustesPublicacionSeleccionadaNombre">
              Los próximos ajustes se van a agregar a: <strong>{{ ajustesPublicacionSeleccionadaNombre }}</strong>
            </small>
          </div>

          <div v-if="ajustesModoNuevaPublicacion" class="mt-2">
            <input
              type="text"
              class="form-control"
              v-model.trim="ajustesNuevoTitulo"
              placeholder="Escribí el título de la nueva publicación"
            >
            <small class="text-muted d-block mt-2">
              Se va a crear una nueva publicación con este título y luego vas a poder seguir agregándole personas si te faltó alguna.
            </small>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <label class="font-weight-bold d-block mb-2">Personas a agregar</label>
          <div class="row no-gutters">
            <div class="col-md-8 mb-2 mb-md-0 pr-md-2">
              <input
                type="text"
                class="form-control"
                v-model.trim="ajustesBusqueda"
                @input="buscarPersonasAjuste"
                @keyup.enter="buscarPersonasAjuste"
                placeholder="Buscar por legajo, DNI o apellido"
              >
            </div>
            <div class="col-md-4">
              <button class="btn btn-outline-primary btn-block" v-on:click="buscarPersonasAjuste()">BUSCAR</button>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-md-end mt-2">
            <span v-if="cargandoAjustes" class="text-muted">Cargando datos para ajustes...</span>
          </div>
        </div>
      </div>

      <div class="table-responsive mt-3" v-if="ajustesResultados.length">
        <table class="table table-sm table-hover">
          <thead>
            <tr>
              <th>Legajo</th>
              <th>DNI</th>
              <th>Nombre</th>
              <th>Sueldo actual</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="persona in ajustesResultados" :key="'resultado-ajuste-' + persona.leg_numero">
              <td>{{ persona.leg_numero }}</td>
              <td>{{ persona.leg_numdoc }}</td>
              <td>{{ obtenerNombreCompleto(persona) }}</td>
              <td>{{ formatearARS(persona.sueldoActual) }}</td>
              <td class="text-right">
                <button class="btn btn-sm btn-success text-white" v-on:click="agregarPersonaAjuste(persona)">AGREGAR</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="alert alert-light mt-3" v-else-if="ajustesBusqueda && !cargandoAjustes">
        No encontré personas con esa búsqueda en la liquidación seleccionada.
      </div>

      <hr>

      <div class="table-responsive" v-if="ajustesSeleccionados.length">
        <table class="table table-bordered ajustes-table">
          <thead>
            <tr>
              <th>Legajo</th>
              <th>DNI</th>
              <th>Nombre</th>
              <th>Sueldo actual</th>
              <th style="width:140px">% ajuste</th>
              <th>Sueldo nuevo</th>
              <th style="width:120px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in ajustesSeleccionados" :key="'ajuste-seleccionado-' + item.legajo">
              <td>{{ item.legajo }}</td>
              <td>{{ item.dni }}</td>
              <td>{{ item.nombreCompleto }}</td>
              <td>{{ formatearARS(item.sueldoActual) }}</td>
              <td>
                <input
                  type="number"
                  step="0.01"
                  class="form-control"
                  v-model="item.porcentaje"
                  @input="recalcularAjuste(index)"
                  placeholder="%"
                >
              </td>
              <td>{{ formatearARS(item.sueldoNuevo) }}</td>
              <td class="text-right">
                <button class="btn btn-sm btn-outline-danger" v-on:click="eliminarAjuste(index)">QUITAR</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="d-md-flex justify-content-between align-items-center mt-3">
          <strong>Total de personas ajustadas: {{ ajustesSeleccionados.length }}</strong>
          <button class="btn btn-danger text-white mt-2 mt-md-0" v-on:click="publicarAjustes()">PUBLICAR AJUSTES</button>
        </div>
      </div>

      <div class="alert alert-warning mt-3 mb-0" v-else>
        Todavía no agregaste personas a la lista de ajustes.
      </div>
    </div>
  </div>
</div>

  <!--<div id="container" style="width:100%; height:400px;"></div>-->
 
<br><br>
   <center>
<div style="width:100%;display: none;" id="botones">
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="">TODOS</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="operaciones">OPERACIONES</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="Administración">ADMINISTRACION</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="comercial">COMERCIAL</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="jefe">JEFES</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="gerente">GERENTES</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="regional">REGIONALES</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="zonal">ZONALES</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="pasante">PASANTES</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="- 523">SUP 1</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="- 563">SUP 2</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="- 564">SUP 3</button>
<button  class="btn btn-info mr-2 mb-2 mb-md-0 text-white  filtro" data-filtro="- 562">SUP PT</button>
</div>
 <br>
    <div id="spreadsheet"></div></center>




<div class="col-md-12 grid-margin stretch-card" id="loading">
                            <div class="card">
                                <div class="card-body">
                                    <div class="card-title w-25"><div class="load-box"></div></div>
                                    <hr>
                                    <div class="row mb-2">
                                        <div class="col-2">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-2">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-4">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-4">
                                            <div class="load-box"></div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row mb-2">
                                        <div class="col-2">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-2">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-4">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-4">
                                            <div class="load-box"></div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row mb-2">
                                        <div class="col-2">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-2">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-4">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-4">
                                            <div class="load-box"></div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-2">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-2">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-4">
                                            <div class="load-box"></div>
                                        </div>
                                        <div class="col-4">
                                            <div class="load-box"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
              
              </div>
            </div>
          </div>
        </div>


            </div>
     

</template>

<script>

 import firebase from "firebase/app";
 import "firebase/database";
 import Swal from 'sweetalert2';

const firedata = firebase.initializeApp({
      // Prod
    apiKey: "AIzaSyBLyOhPH9YaePUSi5fIMjaavlrQVJ2-UnY",
    authDomain: "cantina-89c6a.firebaseapp.com",
    databaseURL: "https://aplicativos.firebaseio.com",
    projectId: "cantina-89c6a",
    storageBucket: "cantina-89c6a.appspot.com",
    messagingSenderId: "353062217145",
    appId: "1:353062217145:web:8849a49a1ec52077"

  },
  "firedata"
);


import $ from 'jquery';
import axios from 'axios';
import 'select2';

var Highcharts = require('highcharts');

import jspreadsheet from 'jspreadsheet-ce';
var numeral = require('numeral');
var liquidacion = "";
var datos_guardados = "";
var costo_guardado="";
var porc_guardado="";

var diferencia_t="";
var porc_dif="";
var txt ="";
var selector = [];
 const addZero=(i)=>{
                    if (i < 10) {
                        i = "0" + i;
                    }
                    return i;
                }
export default {
    name: 'Personal',


    data() {
        return {
            breadcrumbA: 'Inicio',
            breadcrumbB: 'AUMENTOS Y PORCENTAJES GUARDADOS',
            descripcion: 'En este modulo usted podra visualizar todas las proyecciones y aumentos guardados',
            personal: [],
            mostrarAjustes: false,
            cargandoAjustes: false,
            ajustesBusqueda: '',
            ajustesResultados: [],
            ajustesSeleccionados: [],
            personasFuenteAjustes: [],
            costosFuenteAjustes: {},
            liquidacionAjustesCodigo: '',
            liquidacionAjustesTexto: '',
            ajustesPublicaciones: [],
            ajustesPublicacionRegistros: {},
            ajustesPublicacionesCargadasPara: '',
            ajustesBusquedaPublicacion: '',
            ajustesPublicacionSeleccionadaId: '',
            ajustesPublicacionSeleccionadaNombre: '',
            ajustesModoNuevaPublicacion: false,
            ajustesNuevoTitulo: '',
            ultimaPublicacionAjustes: null,
            mostrarBotonAjustes: false,
            proyeccionTable: null,
        }
    },

    async mounted() {






    const axios1 = axios.get('https://aplicativos.firebaseio.com/liquidacion_recibos/AME.json');
    const axios2 = axios.get('https://aplicativos.firebaseio.com/liquidacion_recibos/CAT.json');

    const axios3 = axios.get('https://aplicativos.firebaseio.com/sectores.json?print=pretty');
    const axios4 = axios.get('https://aplicativos.firebaseio.com/distribucion.json?print=pretty');
       

    await axios.all([axios1, axios2,axios3,axios4]).then(axios.spread((america, catering,sectores,distribucion) => {

var liquidaciones = [];


$.each(america.data,function(clave,valor){
    liquidaciones.push({"anio":valor.anio,"liquidacion_america":valor.liquidacion,"mes":valor.mes,"option":valor.option})
    
 });

$.each(catering.data,function(clave,valor){
    liquidaciones.push({"anio":valor.anio,"liquidacion_catering":valor.liquidacion,"mes":valor.mes,"option":valor.option})
    
 });


$.each(sectores.data,function(clave,valor){
  
  localStorage.setItem("operacion-"+valor.id_empresa,valor.operacion)
    
 });



$.each(distribucion.data,function(clave,valor){
  
      $.each(valor,function(cl,val){
      
      localStorage.setItem("ubicacion-"+val.legajo,clave)
        
     });
    
 });


const mergedData = Object.values(liquidaciones.reduce((acc, curr) => {
  const caption = curr.option.split(" ")[0];
  if (!acc[caption]) {
    acc[caption] = [];
  }
  acc[caption].push(curr);
  return acc;
}, {})).map(group => group.reduce((acc, curr) => Object.assign(acc, curr), {}));


localStorage.setItem("liquidaciones",JSON.stringify(mergedData));


    var count = 0;
    var limite = Object.keys(mergedData).length;
     $.each(mergedData,function(clave,valor){
        count++

        var mes = valor.mes;
        if (mes<10) {
            mes="0"+mes
        }
        
        if (count==limite) {

            $("#liquidacion-a").prepend('<option selected="true" value="'+valor.liquidacion_america+'-'+valor.liquidacion_catering+'">'+valor.option+'</option>');
            $("#liquidacion-b").prepend('<option selected="true" data-fecha="'+valor.anio+'-'+mes+'-28" value="'+valor.liquidacion_america+'-'+valor.liquidacion_catering+'">'+valor.option+'</option>');
            selector.push({ [valor.mes+'-'+valor.anio+'-'+valor.liquidacion_america+'-'+valor.liquidacion_catering]:valor.option })

        }else{

            $("#liquidacion-a").prepend('<option value="'+valor.liquidacion_america+'-'+valor.liquidacion_catering+'">'+valor.option+'</option>');
            $("#liquidacion-b").prepend('<option data-fecha="'+valor.anio+'-'+mes+'-28" value="'+valor.liquidacion_america+'-'+valor.liquidacion_catering+'">'+valor.option+'</option>');
            selector.push({ [valor.mes+'-'+valor.anio+'-'+valor.liquidacion_america+'-'+valor.liquidacion_catering]:valor.option })

        }
        
     

     });




})).then(() => {


            
$("#loading").hide();
$(".table").hide();
               

        });



    },
     methods: {
        formatearARS(valor) {
            const numero = this.limpiarNumero(valor);
            return new Intl.NumberFormat('es-AR', {
                style: 'currency',
                currency: 'ARS',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(numero);
        },

        limpiarNumero(valor) {
            if (valor === null || valor === undefined) {
                return 0;
            }

            if (typeof valor === 'number') {
                return isNaN(valor) ? 0 : valor;
            }

            let texto = String(valor)
                .replace(/<[^>]*>/g, '')
                .replace(/\s+/g, '')
                .replace(/\$/g, '')
                .replace(/%/g, '');

            if (!texto) {
                return 0;
            }

            const tieneComa = texto.indexOf(',') !== -1;
            const tienePunto = texto.indexOf('.') !== -1;

            if (tieneComa && tienePunto) {
                texto = texto.replace(/\./g, '').replace(',', '.');
            } else if (tieneComa) {
                texto = texto.replace(',', '.');
            }

            texto = texto.replace(/[^0-9.-]/g, '');

            const numero = parseFloat(texto);
            return isNaN(numero) ? 0 : numero;
        },

        normalizarTexto(valor) {
            return String(valor || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim();
        },
        escaparHtmlExcel(valor) {
            return String(valor === null || valor === undefined ? '' : valor)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        },

        textoPlanoExcel(valor) {
            if (valor === null || valor === undefined) {
                return '';
            }

            const div = document.createElement('div');
            div.innerHTML = String(valor);

            return String(div.textContent || div.innerText || '')
                .replace(/\s+/g, ' ')
                .trim();
        },

        descargarBlobExcel(contenido, nombreArchivo) {
            const blob = new Blob(['\ufeff', contenido], {
                type: 'application/vnd.ms-excel;charset=utf-8;'
            });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, nombreArchivo);
                return;
            }

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nombreArchivo;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },

        descargarExcelProyeccion() {
            const sheet = this.proyeccionTable;

            if (!sheet || !sheet.options) {
                Swal.fire({
                    icon: 'info',
                    title: 'Sin datos para exportar',
                    text: 'Primero generá la proyección y luego descargá el Excel.'
                });
                return;
            }

            const headers = (sheet.options.columns || []).map((columna) => {
                return this.textoPlanoExcel(columna && columna.title ? columna.title : '');
            });

            let datos = [];
            try {
                datos = sheet.getData(false, false) || [];
            } catch (error) {
                datos = sheet.options.data || [];
            }

            const filas = [];
            filas.push(headers);

            datos.forEach((fila) => {
                filas.push((fila || []).map((valor) => this.textoPlanoExcel(valor)));
            });

            const footers = [];
            $('#spreadsheet .jexcel tfoot tr').each((index, tr) => {
                const filaFooter = [];
                $(tr).children('td').each((i, td) => {
                    if (i === 0) {
                        return;
                    }
                    filaFooter.push(this.textoPlanoExcel($(td).html()));
                });

                if (filaFooter.some((valor) => String(valor || '').trim() !== '')) {
                    footers.push(filaFooter);
                }
            });

            footers.forEach((filaFooter) => filas.push(filaFooter));

            if (filas.length <= 1) {
                Swal.fire({
                    icon: 'info',
                    title: 'Sin datos para exportar',
                    text: 'La grilla no tiene registros para descargar.'
                });
                return;
            }

            const tablaHtml = filas.map((fila, index) => {
                const tag = index === 0 ? 'th' : 'td';
                const celdas = fila.map((valor) => {
                    return '<' + tag + ' style="border:1px solid #999;padding:6px;">' + this.escaparHtmlExcel(valor) + '</' + tag + '>';
                }).join('');
                return '<tr>' + celdas + '</tr>';
            }).join('');

            const html = `
                <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
                    <head>
                        <meta charset="UTF-8">
                        <!--[if gte mso 9]>
                        <xml>
                            <x:ExcelWorkbook>
                                <x:ExcelWorksheets>
                                    <x:ExcelWorksheet>
                                        <x:Name>Proyección</x:Name>
                                        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                                    </x:ExcelWorksheet>
                                </x:ExcelWorksheets>
                            </x:ExcelWorkbook>
                        </xml>
                        <![endif]-->
                    </head>
                    <body>
                        <table>${tablaHtml}</table>
                    </body>
                </html>
            `;

            const liquidacionTexto = this.normalizarTexto($('#liquidacion-a option:selected').text() || 'proyeccion')
                .replace(/[^a-z0-9]+/g, '_')
                .replace(/^_+|_+$/g, '') || 'proyeccion';
            const fecha = new Date().toISOString().slice(0, 10);
            const nombreArchivo = `aumentos_porcentajes_${liquidacionTexto}_${fecha}.xls`;

            this.descargarBlobExcel(html, nombreArchivo);
        },


        obtenerBasicoRegistroCosto(registro) {
            if (!registro) {
                return 0;
            }

            if (registro.datos && registro.datos.basico != null) {
                return this.limpiarNumero(registro.datos.basico);
            }

            if (registro.remunerativo && registro.remunerativo.monto != null) {
                return this.limpiarNumero(registro.remunerativo.monto);
            }

            return 0;
        },

        obtenerNombreCompleto(persona) {
            const apellido = String(persona && persona.leg_apellido ? persona.leg_apellido : '').trim();
            const nombre = String(persona && persona.leg_nombre ? persona.leg_nombre : '').trim();
            return (apellido + ' ' + nombre).trim();
        },

        async prepararDatosAjustes() {
            const liquidacionSeleccionada = $("#liquidacion-a option:selected").val();
            const textoLiquidacion = $("#liquidacion-a option:selected").text();

            if (!liquidacionSeleccionada) {
                Swal.fire('Atención', 'Primero seleccioná una liquidación.', 'warning');
                return false;
            }

            if (
                this.liquidacionAjustesCodigo === liquidacionSeleccionada &&
                this.personasFuenteAjustes.length > 0 &&
                Object.keys(this.costosFuenteAjustes || {}).length > 0 &&
                (
                    this.ajustesPublicacionesCargadasPara === liquidacionSeleccionada ||
                    (this.ajustesModoNuevaPublicacion && !this.ajustesPublicaciones.length)
                )
            ) {
                return true;
            }

            this.cargandoAjustes = true;

            try {
                const liqAme = liquidacionSeleccionada.split("-")[0];
                const liqCat = liquidacionSeleccionada.split("-")[1];

                const [personalResp, costoAResp, costoBResp] = await axios.all([
                    axios.get('https://auth.foodservice.com.ar/index_dev.php?type=personal&access_token=1234567'),
                    axios.get('https://auth.foodservice.com.ar/index_dev.php?type=costos_ame&liquidacion=' + liqAme + '&access_token=1234567'),
                    axios.get('https://auth.foodservice.com.ar/index_dev.php?type=costos_cat&liquidacion=' + liqCat + '&access_token=1234567')
                ]);

                const personas = Array.isArray(personalResp.data)
                    ? personalResp.data
                    : Object.values(personalResp.data || {});

                const costos = Object.assign({}, costoAResp.data || {}, costoBResp.data || {});
                const cambioLiquidacion = this.liquidacionAjustesCodigo && this.liquidacionAjustesCodigo !== liquidacionSeleccionada;

                this.personasFuenteAjustes = personas;
                this.costosFuenteAjustes = costos;
                this.liquidacionAjustesCodigo = liquidacionSeleccionada;
                this.liquidacionAjustesTexto = textoLiquidacion;

                if (cambioLiquidacion) {
                    this.ajustesSeleccionados = [];
                    this.ajustesPublicaciones = [];
                    this.ajustesPublicacionRegistros = {};
                    this.ajustesPublicacionesCargadasPara = '';
                    this.ajustesBusquedaPublicacion = '';
                    this.ajustesPublicacionSeleccionadaId = '';
                    this.ajustesPublicacionSeleccionadaNombre = '';
                    this.ajustesModoNuevaPublicacion = false;
                    this.ajustesNuevoTitulo = '';
                    this.ultimaPublicacionAjustes = null;
                }

                await this.cargarPublicacionesAjustes(cambioLiquidacion);

                if (this.ajustesBusqueda) {
                    this.buscarPersonasAjuste();
                }

                return true;
            } catch (error) {
                console.log(error);
                Swal.fire('Error', 'No pude cargar los datos necesarios para ajustes.', 'error');
                return false;
            } finally {
                this.cargandoAjustes = false;
            }
        },

        async toggleAjustes() {
            if (!this.mostrarAjustes) {
                const ok = await this.prepararDatosAjustes();
                if (!ok) {
                    return;
                }
            }
            this.mostrarAjustes = !this.mostrarAjustes;
        },

        buscarPersonasAjuste() {
            const query = this.normalizarTexto(this.ajustesBusqueda);

            if (!query) {
                this.ajustesResultados = [];
                return;
            }

            const vistos = {};
            const resultados = [];

            for (let i = 0; i < this.personasFuenteAjustes.length; i++) {
                const persona = this.personasFuenteAjustes[i];
                if (!persona || persona.leg_numero == null) {
                    continue;
                }

                const legajo = String(persona.leg_numero || '').trim();
                const dni = String(persona.leg_numdoc || '').trim();
                const apellido = this.normalizarTexto(persona.leg_apellido || '');
                const nombre = this.normalizarTexto(persona.leg_nombre || '');
                const nombreCompleto = (apellido + ' ' + nombre).trim();

                const coincide =
                    legajo.indexOf(query) !== -1 ||
                    dni.indexOf(query) !== -1 ||
                    apellido.indexOf(query) !== -1 ||
                    nombre.indexOf(query) !== -1 ||
                    nombreCompleto.indexOf(query) !== -1;

                if (!coincide || vistos[legajo]) {
                    continue;
                }

                const costoRegistro = this.costosFuenteAjustes[legajo] || this.costosFuenteAjustes[parseInt(legajo)];
                const sueldoActual = this.obtenerBasicoRegistroCosto(costoRegistro);

                resultados.push({
                    ...persona,
                    sueldoActual
                });

                vistos[legajo] = true;

                if (resultados.length >= 25) {
                    break;
                }
            }

            this.ajustesResultados = resultados;
        },

        agregarPersonaAjuste(persona) {
            const legajo = String(persona.leg_numero);
            const yaExiste = this.ajustesSeleccionados.some(item => String(item.legajo) === legajo);

            if (yaExiste) {
                Swal.fire('Atención', 'Esa persona ya fue agregada a los ajustes.', 'warning');
                return;
            }

            const costoRegistro = this.costosFuenteAjustes[legajo] || this.costosFuenteAjustes[parseInt(legajo)];
            const sueldoActual = this.obtenerBasicoRegistroCosto(costoRegistro);

            this.ajustesSeleccionados.push({
                legajo: legajo,
                dni: persona.leg_numdoc || '',
                nombre: persona.leg_nombre || '',
                apellido: persona.leg_apellido || '',
                nombreCompleto: this.obtenerNombreCompleto(persona),
                sueldoActual: sueldoActual,
                porcentaje: '',
                sueldoNuevo: sueldoActual
            });
        },

        recalcularAjuste(index) {
            const item = this.ajustesSeleccionados[index];
            if (!item) {
                return;
            }

            const sueldoActual = this.limpiarNumero(item.sueldoActual);
            const porcentaje = this.limpiarNumero(item.porcentaje);

            item.porcentaje = String(item.porcentaje || '').replace(',', '.');
            item.sueldoNuevo = Math.round((sueldoActual * (1 + (porcentaje / 100))) * 100) / 100;

            this.$forceUpdate();
        },

        eliminarAjuste(index) {
            this.ajustesSeleccionados.splice(index, 1);
        },

        obtenerIdPublicacionAjustes(registro) {
            if (registro && registro.publication_id) {
                return String(registro.publication_id);
            }

            const nombre = String((registro && (registro.nombre_publicacion || registro.nombre)) || 'sin_titulo').trim();
            const fecha = String((registro && registro.fecha) || '').trim();
            const creador = String((registro && registro.creador_dni) || '').trim();
            return [this.normalizarTexto(nombre), fecha, creador].join('|');
        },

        obtenerNombrePublicacionAjustes(registro) {
            return String((registro && (registro.nombre_publicacion || registro.nombre)) || 'SIN TÍTULO').trim();
        },

        obtenerValorOrdenablePublicacion(valor) {
            const texto = String(valor || '').trim();
            if (!texto) {
                return 0;
            }

            const fecha = new Date(texto.replace(' ', 'T'));
            const tiempo = fecha.getTime();
            if (!isNaN(tiempo)) {
                return tiempo;
            }

            return texto;
        },

        publicacionesAjustesFiltradas() {
            const query = this.normalizarTexto(this.ajustesBusquedaPublicacion);
            if (!query) {
                return this.ajustesPublicaciones;
            }

            return this.ajustesPublicaciones.filter((publicacion) => {
                const texto = this.normalizarTexto([
                    publicacion.nombre,
                    publicacion.creador_name,
                    publicacion.fecha,
                    publicacion.timestamp
                ].join(' '));

                return texto.indexOf(query) !== -1;
            });
        },

        sincronizarPublicacionSeleccionada() {
            const publicacion = this.ajustesPublicaciones.find(item => item.id === this.ajustesPublicacionSeleccionadaId);
            this.ajustesPublicacionSeleccionadaNombre = publicacion ? publicacion.nombre : '';
        },

        usarUltimaPublicacionAjustes() {
            if (!this.ajustesPublicaciones.length) {
                this.activarNuevaPublicacionAjustes();
                return;
            }

            const ultima = this.ajustesPublicaciones[0];
            this.ajustesModoNuevaPublicacion = false;
            this.ajustesNuevoTitulo = '';
            this.ajustesPublicacionSeleccionadaId = ultima.id;
            this.ajustesPublicacionSeleccionadaNombre = ultima.nombre;
        },

        activarNuevaPublicacionAjustes() {
            this.ajustesModoNuevaPublicacion = true;
            this.ajustesPublicacionSeleccionadaId = '';
            this.ajustesPublicacionSeleccionadaNombre = '';
        },

        resolverPublicacionAjustes() {
            if (this.ajustesModoNuevaPublicacion || !this.ajustesPublicacionSeleccionadaId) {
                const titulo = String(this.ajustesNuevoTitulo || '').trim();
                if (!titulo) {
                    return {
                        ok: false,
                        mensaje: 'Necesitás escribir el título de la nueva publicación antes de publicar los ajustes.'
                    };
                }

                return {
                    ok: true,
                    publicationId: 'pub-' + Date.now() + '-' + Math.random().toString(36).substr(2, 6),
                    nombrePublicacion: titulo,
                    esNueva: true
                };
            }

            const publicacion = this.ajustesPublicaciones.find(item => item.id === this.ajustesPublicacionSeleccionadaId);
            if (!publicacion) {
                return {
                    ok: false,
                    mensaje: 'Seleccioná una publicación existente o creá una nueva antes de publicar.'
                };
            }

            return {
                ok: true,
                publicationId: publicacion.id,
                nombrePublicacion: publicacion.nombre,
                esNueva: false
            };
        },

        async cargarPublicacionesAjustes(force = false) {
            if (!this.liquidacionAjustesCodigo) {
                return;
            }

            if (!force && this.ajustesPublicacionesCargadasPara === this.liquidacionAjustesCodigo && this.ajustesPublicaciones.length) {
                return;
            }

            try {
                const snapshot = await firedata.database().ref('ajustespro/' + this.liquidacionAjustesCodigo).once('value');
                const data = snapshot.val() || {};
                const agrupadas = {};
                const registros = {};

                Object.keys(data).forEach((firebaseKey) => {
                    const registro = data[firebaseKey] || {};
                    const publicationId = this.obtenerIdPublicacionAjustes(registro);
                    const nombre = this.obtenerNombrePublicacionAjustes(registro);
                    const marcaTiempo = registro.timestamp || registro.fecha || '';
                    const valorOrdenable = this.obtenerValorOrdenablePublicacion(marcaTiempo);
                    const legajo = String(registro.legajo || '').trim();

                    if (!agrupadas[publicationId]) {
                        agrupadas[publicationId] = {
                            id: publicationId,
                            nombre: nombre,
                            fecha: registro.fecha || '',
                            timestamp: registro.timestamp || '',
                            creador_dni: registro.creador_dni || '',
                            creador_name: registro.creador_name || '',
                            cantidad: 0,
                            orden: valorOrdenable
                        };
                    }

                    agrupadas[publicationId].cantidad += 1;

                    if (valorOrdenable >= agrupadas[publicationId].orden) {
                        agrupadas[publicationId].fecha = registro.fecha || agrupadas[publicationId].fecha;
                        agrupadas[publicationId].timestamp = registro.timestamp || agrupadas[publicationId].timestamp;
                        agrupadas[publicationId].creador_dni = registro.creador_dni || agrupadas[publicationId].creador_dni;
                        agrupadas[publicationId].creador_name = registro.creador_name || agrupadas[publicationId].creador_name;
                        agrupadas[publicationId].orden = valorOrdenable;
                    }

                    if (!registros[publicationId]) {
                        registros[publicationId] = {};
                    }

                    if (legajo) {
                        registros[publicationId][legajo] = Object.assign({}, registro, { firebaseKey: firebaseKey });
                    }
                });

                const publicaciones = Object.values(agrupadas).sort((a, b) => {
                    if (a.orden === b.orden) {
                        return String(b.timestamp || b.fecha || '').localeCompare(String(a.timestamp || a.fecha || ''));
                    }
                    return b.orden > a.orden ? 1 : -1;
                });

                this.ajustesPublicaciones = publicaciones;
                this.ajustesPublicacionRegistros = registros;
                this.ajustesPublicacionesCargadasPara = this.liquidacionAjustesCodigo;
                this.ultimaPublicacionAjustes = publicaciones.length ? publicaciones[0] : null;

                if (this.ajustesModoNuevaPublicacion) {
                    return;
                }

                if (this.ajustesPublicacionSeleccionadaId) {
                    const existe = publicaciones.some(item => item.id === this.ajustesPublicacionSeleccionadaId);
                    if (existe) {
                        this.sincronizarPublicacionSeleccionada();
                        return;
                    }
                }

                if (publicaciones.length) {
                    this.ajustesPublicacionSeleccionadaId = publicaciones[0].id;
                    this.ajustesPublicacionSeleccionadaNombre = publicaciones[0].nombre;
                    this.ajustesModoNuevaPublicacion = false;
                } else {
                    this.ajustesPublicacionSeleccionadaId = '';
                    this.ajustesPublicacionSeleccionadaNombre = '';
                    this.ajustesModoNuevaPublicacion = true;
                }
            } catch (error) {
                console.log(error);
                Swal.fire('Error', 'No pude cargar las publicaciones de ajustes existentes.', 'error');
            }
        },

        async publicarAjustes() {
            const ok = await this.prepararDatosAjustes();
            if (!ok) {
                return;
            }

            if (!this.ajustesSeleccionados.length) {
                Swal.fire('Atención', 'No hay ajustes para publicar.', 'warning');
                return;
            }

            const contextoPublicacion = this.resolverPublicacionAjustes();
            if (!contextoPublicacion.ok) {
                Swal.fire('Atención', contextoPublicacion.mensaje, 'warning');
                return;
            }

            const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
            const ahora = new Date();
            const anio = ahora.getFullYear();
            const mes = String(ahora.getMonth() + 1).padStart(2, '0');
            const dia = String(ahora.getDate()).padStart(2, '0');
            const hora = String(ahora.getHours()).padStart(2, '0');
            const minutos = String(ahora.getMinutes()).padStart(2, '0');
            const segundos = String(ahora.getSeconds()).padStart(2, '0');
            const fechaSql = anio + '-' + mes + '-' + dia;
            const timestamp = fechaSql + ' ' + hora + ':' + minutos + ':' + segundos;

            const confirmacion = await Swal.fire({
                title: 'Confirmar publicación',
                html: 'Vas a publicar <b>' + this.ajustesSeleccionados.length + '</b> ajuste(s) en <b>' + contextoPublicacion.nombrePublicacion + '</b>.',
                icon: 'question',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Publicar'
            });

            if (!confirmacion.isConfirmed) {
                return;
            }

            const items = this.ajustesSeleccionados.map((item) => ({
                legajo: item.legajo,
                dni: item.dni,
                nombre: item.nombre,
                apellido: item.apellido,
                nombreCompleto: item.nombreCompleto,
                sueldoActual: this.limpiarNumero(item.sueldoActual),
                porcentaje: this.limpiarNumero(item.porcentaje),
                sueldoNuevo: this.limpiarNumero(item.sueldoNuevo)
            }));

            try {
                const refAjustes = firedata.database().ref('ajustespro/' + this.liquidacionAjustesCodigo);
                const registrosExistentes = this.ajustesPublicacionRegistros[contextoPublicacion.publicationId] || {};

                await Promise.all(items.map((item) => {
                    const payload = {
                        publication_id: contextoPublicacion.publicationId,
                        nombre_publicacion: contextoPublicacion.nombrePublicacion,
                        tipo: 'ajuste_manual',
                        liquidacion: this.liquidacionAjustesCodigo,
                        inicio: this.liquidacionAjustesTexto,
                        fecha: fechaSql,
                        timestamp: timestamp,
                        creador_dni: userData.leg_numdoc || '',
                        creador_name: ((userData.leg_nombre || '') + ' ' + (userData.leg_apellido || '')).trim(),
                        legajo: item.legajo,
                        dni: item.dni,
                        nombre: item.nombre,
                        apellido: item.apellido,
                        nombreCompleto: item.nombreCompleto,
                        sueldoActual: item.sueldoActual,
                        porcentaje: item.porcentaje,
                        sueldoNuevo: item.sueldoNuevo
                    };

                    const existente = registrosExistentes[String(item.legajo)];
                    if (existente && existente.firebaseKey) {
                        return refAjustes.child(existente.firebaseKey).update(payload);
                    }

                    return refAjustes.push(payload);
                }));

                await this.cargarPublicacionesAjustes(true);
                this.ajustesModoNuevaPublicacion = false;
                this.ajustesPublicacionSeleccionadaId = contextoPublicacion.publicationId;
                this.ajustesPublicacionSeleccionadaNombre = contextoPublicacion.nombrePublicacion;
                this.ajustesNuevoTitulo = '';

                Swal.fire(
                    'Publicado',
                    'Los ajustes fueron publicados correctamente en el nodo ajustespro.',
                    'success'
                );

                this.ajustesSeleccionados = [];
                this.ajustesBusqueda = '';
                this.ajustesResultados = [];
            } catch (error) {
                console.log(error);
                Swal.fire('Error', 'No pude publicar los ajustes.', 'error');
            }
        },

        guardar() {

               
                    (async function() {


        const userData = JSON.parse(sessionStorage.getItem('userData') || '{}') || {};
        var h = new Date();
        var hora = addZero(h.getHours());
        var minutos = ("0" + h.getMinutes()).substr(-2);
        var segundos = ("0" + h.getSeconds()).substr(-2);
        var horaActual = hora + ":" + minutos + ":" + segundos;

        var hoy = new Date();

        var m = hoy.getMonth() + 1;
        var mes = m < 10 ? "0" + m : m;
        var dia = hoy.getDate();
        dia = dia < 10 ? "0" + dia : dia;
        var fechaActualok = dia + "-" + mes + "-" + hoy.getFullYear();
        var fechaActualok_b = hoy.getFullYear() + "-" + mes + "-" + dia;




            

           

            


                await Swal.fire({
                      title: 'Escribe un nombre para identificar tus aumentos',
                      input: 'text',
                      inputAttributes: {
                        autocapitalize: 'off'
                      },
                      showCancelButton: true,
                      cancelButtonText: 'Cancelar',
                      confirmButtonText: 'Guardar',
                      showLoaderOnConfirm: true,
                      preConfirm: (login) => {
                       
                            firebase.database().ref('costos_publicados/').push({
                              nombre:login,
                              fecha:fechaActualok_b,
                              timestamp:fechaActualok_b+" "+horaActual,
                              creador_dni:userData.leg_numdoc,
                              creador_name:((userData.leg_nombre || '') + ' ' + (userData.leg_apellido || '')).trim(),
                              liquidacion:localStorage.getItem("costo_liq"),
                              inicio:$("#liquidacion-a option:selected").text()
                              

                            })
                            .then(()=>{
                              
                                 Swal.fire(
                                      "Guardado exitosamente",
                                      "Los datos fueron guardados cotrrectamente, podras visualizarlos en la secciòn Autorizados Guardados",
                                      "success"
                                    );

                            })
                            .catch(e => {
                              console.log(e);
                            });


                      },
                      allowOutsideClick: () => !Swal.isLoading()
                    }).then((result) => {
                      if (result.isConfirmed) {
                        console.log(result);
                      }
                    })

            


})();

           
         },

        removeDuplicates(originalArray, prop) {
             var newArray = [];
             var lookupObject  = {};

             for(var i in originalArray) {
                lookupObject[originalArray[i][prop]] = originalArray[i];
             }

             for(i in lookupObject) {
                 newArray.push(lookupObject[i]);
             }
              return newArray;
         },

         calcular(legajo){

             const moneda = (numero) => {
              const formatoMoneda = new Intl.NumberFormat('es-AR', {
                style: 'currency',
                currency: 'ARS',
                minimumFractionDigits: 0, // Establecer el número mínimo de dígitos decimales a cero
                maximumFractionDigits: 0, // Establecer el número máximo de dígitos decimales a cero
                currencyDisplay: 'narrowSymbol' // Opción para eliminar el símbolo de moneda
              });

              const numeroFormateado = formatoMoneda.format(numero);

              return numeroFormateado;
            }


                  var per = parseFloat($("#basico_b-"+legajo).val());
                  var basico = parseFloat($("#basico_a-"+legajo).html());
                  var cuenta = (basico*per)/100;
                  var total = parseFloat(basico+cuenta).toFixed(3);





                    if (isNaN(total)||total==0) {
                      total = 0;
                      $("#proyeccion_a-"+legajo).html(0)
                    } else {
                      $("#proyeccion_a-"+legajo).html(total)
                    }


                    //DIFERENCIA

                    var direfencia = total-basico;
                    console.log(direfencia)

                    if (isNaN(direfencia)||direfencia<0) {
                      
                      $("#diferencia-"+legajo).html(0)
                      sessionStorage.setItem("total-"+legajo,0)
                    } else {
                      $("#diferencia-"+legajo).html(moneda(direfencia.toFixed(3).replace(".","")))
                      sessionStorage.setItem("total-"+legajo,direfencia.toFixed(3).replace(".",""))
                    }



   var table = $('#empresas').DataTable();                     
  // Obtener los datos de la columna "País"
  var data = table.column(0).data();

  // Crear un array de valores únicos de la columna "País"
  var uniqueData = data.unique();

  
  var sumar = 0;
  // Agregar las opciones del filtro select con los valores únicos de la columna "País"
  $.each(uniqueData, function(i, val) {


console.log(liquidacion)
    if (sessionStorage.getItem("total-"+val) !== null) {
        sumar+=parseFloat(sessionStorage.getItem("total-"+val));

       

    }
    
        
    
  });

  console.log("SUMA == "+sumar)


const numeroMoneda = localStorage.getItem("costo");
const numeroEntero = parseFloat(numeroMoneda.replace(/\$|\.+/g, ''));
var costo=moneda(numeroEntero+sumar); // output: 112337086
var costo_entero=numeroEntero+sumar;
//$("#total_b").html(costo)                   

 

 var porcentajeAumento = ((costo_entero - numeroEntero) / numeroEntero) * 100;
 var porcentaje = parseFloat(porcentajeAumento.toFixed(2));
 console.log("PORCENTAJE :: "+porcentaje)

 var resta = costo_entero-numeroEntero;

if (porcentaje>0.00) {
      //$("#porc_cos_a").html('<span class="arraw igual badge badge-danger"> %'+porcentaje+' ↑</span>')   
}else{
     //$("#porc_cos_a").html('<span class="arraw igual badge badge-light"> %'+porcentaje+' ↔</span>')   
}

if (costo_entero!=numeroEntero) {
      $("#diferencia_t").html("$"+moneda(resta))
      $("#porc_dif").html('<span class="arraw igual badge badge-danger">↑</span>')   
}else{
     $("#diferencia_t").html("$"+moneda(resta))
     $("#porc_dif").html('<span class="arraw igual badge badge-light">↔</span>')     
}


                


                  
        },

        async comparar(){

            const vm = this;

            $("#loading").show();

            

            const moneda = (numero) => {
              const formatoMoneda = new Intl.NumberFormat('es-AR', {
                style: 'currency',
                currency: 'ARS',
                minimumFractionDigits: 0, // Establecer el número mínimo de dígitos decimales a cero
                maximumFractionDigits: 0, // Establecer el número máximo de dígitos decimales a cero
                currencyDisplay: 'narrowSymbol' // Opción para eliminar el símbolo de moneda
              });

              const numeroFormateado = formatoMoneda.format(numero);

              return numeroFormateado;
            }


          
        $(".table").show();
        $("#alerta").hide(); 

        $("#guardar").show(); 
         $("#botones").show(); 

        $('#spreadsheet').html("");

         var liq_1_a = $("#liquidacion-a option:selected").val().split("-")[0];
         var liq_1_b = $("#liquidacion-a option:selected").val().split("-")[1];
         
         localStorage.setItem("costo_liq",liq_1_a+'-'+liq_1_b);

         $(".fecha1").html($("#liquidacion-a option:selected").text())
         $(".fecha2").html( $("#liquidacion-b option:selected").text())

        const data = JSON.parse(localStorage.getItem("liquidaciones"));
        const ultimoResultado = data[data.length - 1];
        const liquidacionAmericaUltimoResultado = ultimoResultado["liquidacion_america"];
        const liquidacionCateringUltimoResultado = ultimoResultado["liquidacion_catering"];
        const ultimoMes = ultimoResultado["option"];

        console.log(liquidacionAmericaUltimoResultado)
        console.log(liquidacionCateringUltimoResultado)
         

        const axiosrequest1 = axios.get('https://auth.foodservice.com.ar/index_dev.php?type=personal&access_token=1234567');
        const axiosrequest2 = axios.get('https://aplicativos.firebaseio.com/categorias.json?print=pretty');

        
        const axiosrequest3 = axios.get('https://auth.foodservice.com.ar/index_dev.php?type=costos_ame&liquidacion='+liq_1_a+'&access_token=1234567');
        const axiosrequest4 = axios.get('https://auth.foodservice.com.ar/index_dev.php?type=costos_cat&liquidacion='+liq_1_b+'&access_token=1234567');

        const axiosrequest5 = axios.get('https://aplicativos.firebaseio.com/proyecciones/'+liq_1_a+'-'+liq_1_b+'.json');



        const axiosrequest6 = axios.get('https://auth.foodservice.com.ar/index_dev.php?type=costos_ame&liquidacion='+liquidacionAmericaUltimoResultado+'&access_token=1234567');
        const axiosrequest7 = axios.get('https://auth.foodservice.com.ar/index_dev.php?type=costos_cat&liquidacion='+liquidacionCateringUltimoResultado+'&access_token=1234567');

        const axiosrequest8 = axios.get('https://aplicativos.firebaseio.com/legales.json?print=pretty');

        const axiosrequest9 = axios.get('https://aplicativos.firebaseio.com/requisitoria_salarial/'+liq_1_a+'-'+liq_1_b+'.json');

        const axiosrequest10 = axios.get('https://aplicativos.firebaseio.com/ajuste_salarial.json?print=pretty');

        const axiosrequest11 = axios.get('https://aplicativos.firebaseio.com/categorias_cat.json?print=pretty');
       

       await axios.all([axiosrequest1, axiosrequest2, axiosrequest3,axiosrequest4,axiosrequest5,axiosrequest6,axiosrequest7,axiosrequest8,axiosrequest9,axiosrequest10,axiosrequest11]).then(axios.spread((personal, categorias, costo_a,costo_b,proyeccion,costos_pa,costos_pb,legales,ajustes,ajuste_requi,categorias_cat) => {

            
           
            const costox_a = Object.assign({}, costo_a.data, costo_b.data);
            
            const costox_b = Object.assign({}, costos_pa.data, costos_pb.data);

            const obtenerDatosCostoSeguro = (registro) => {
                if (!registro || typeof registro !== 'object') {
                    return {};
                }
                return registro.datos && typeof registro.datos === 'object' ? registro.datos : {};
            };

            const obtenerBasicoSeguro = (registro) => {
                const datos = obtenerDatosCostoSeguro(registro);
                if (datos.basico != null && datos.basico !== '') {
                    return vm.limpiarNumero(datos.basico);
                }
                if (registro && registro.remunerativo && registro.remunerativo.monto != null) {
                    return vm.limpiarNumero(registro.remunerativo.monto);
                }
                return 0;
            };

            const obtenerNombreRegistroSeguro = (registro, legajo) => {
                const datos = obtenerDatosCostoSeguro(registro);
                if (datos.nombre != null && String(datos.nombre).trim() !== '') {
                    return String(datos.nombre).trim();
                }

                let personaRegistro = null;
                $.each(personal.data || [], function(_, personaItem) {
                    if (!personaRegistro && String(personaItem.leg_numero) === String(legajo)) {
                        personaRegistro = personaItem;
                    }
                });

                if (personaRegistro) {
                    const apellido = String(personaRegistro.leg_apellido || '').trim();
                    const nombre = String(personaRegistro.leg_nombre || '').trim();
                    return [apellido, nombre].filter(Boolean).join(', ');
                }

                return String(legajo);
            };
            

            vm.personasFuenteAjustes = Array.isArray(personal.data) ? personal.data : Object.values(personal.data || {});
            vm.costosFuenteAjustes = costox_a;
            vm.liquidacionAjustesCodigo = liq_1_a+'-'+liq_1_b;
            vm.liquidacionAjustesTexto = $("#liquidacion-a option:selected").text();

            $("#personal_a").html(Object.keys(costox_a).length);
            $("#personal_b").html(Object.keys(costox_b).length);

            var c_a = 0;
            $.each(costox_a, function(clave, value) {
                c_a += obtenerBasicoSeguro(value);
            })

             var num_a = c_a.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g,'$1.');
                 num_a = num_a.split('').reverse().join('').replace(/^[.]/,'');
            $("#total_a").html("$"+num_a);


             var c_b = 0;
            $.each(costox_a, function(clave, value) {
                c_b += value && value.costo_laboral && value.costo_laboral.monto != null ? parseFloat(value.costo_laboral.monto.toFixed(2)) : 0;


            })

         

            //$("#total_b").html("$"+num_a);
            localStorage.setItem("costo",num_a)

            var resultado = c_a-c_a;

             var result = resultado.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g,'$1.');
                 result = result.split('').reverse().join('').replace(/^[.]/,'');

            $("#diferencia_t").html("$"+result);




            var pa = parseFloat($("#personal_a").text());
            var pb = parseFloat($("#personal_a").text());
            var porc_a = (pb-pa)*100/pa;

            var porcx_a = "";

            if (porc_a>0) {
                porcx_a = '<span class="arraw up badge badge-danger"> %'+Math.round(porc_a)+' ↑</span>';
            }
            if (porc_a<0) {
                porcx_a = '<span class="arraw down badge badge-success"> %'+Math.round(porc_a)+' ↓</span>';
            }
            if (porc_a==0) {
                porcx_a = '<span class="arraw igual badge badge-light"> %'+Math.round(porc_a)+' ↔</span>';
            }

            $("#porc_per_a").html(porcx_a);



            var pca = parseFloat($("#total_a").text().replace("$",""));
            var pcb = parseFloat($("#total_a").text().replace("$",""));
            var porc_b = (pcb-pca)*100/pca;

            var porcx_b = "";

            if (porc_b>0) {
                porcx_b = '<span class="arraw up badge badge-danger"> %'+Math.round(porc_b)+' ↑</span>';
            }
            if (porc_b<0) {
                porcx_b = '<span class="arraw down badge badge-success"> %'+Math.round(porc_b)+' ↓</span>';
            }
            if (porc_b==0) {
                porcx_b = '<span class="arraw igual badge badge-light"> %'+Math.round(porc_b)+' ↔</span>';
            }

            $("#porc_cos_a").html(porcx_b);


            var dif_a = parseFloat($("#total_a").text().replace("$",""));
           

            var difx_b = "";

            if (dif_a>0) {
                difx_b = '<span class="arraw up badge badge-danger"> ↑ </span>';
            }
            if (dif_a<0) {
                difx_b = '<span class="arraw down badge badge-success"> ↓ </span>';
            }
            if (dif_a==0) {
                difx_b = '<span class="arraw igual badge badge-light"> ↔ </span>';
            }

            $("#porc_dif").html('<span class="arraw igual badge badge-light"> ↔ </span>');


            const convencionado = (id) => {
                var convenio = "";
                $.each(personal.data, function(clave, value) {

                    if (value.leg_numero == id) {
                        convenio = value.leg_convencionado;
                    }
                })
                return convenio;
            }


            const result_categoria = (id) => {
                var categoria = "";
                $.each(categorias.data, function(clave, value) {

                    if (value.codigo == id) {
                        categoria = value.nombre;
                    }
                })
                return categoria;
            }




            const result_categoria_cat = (id) => {
                var categoria = "";
                $.each(categorias_cat.data, function(clave, value) {

                    if (value.codigo == id) {
                        categoria = value.nombre;
                    }
                })
                return categoria;
            }



         
           


            

            const result_remunerativo_a = (id) => {
                var remunerativo = "";
                $.each(costox_a, function(clave, value) {

                    if (clave == id) {
                        remunerativo = value.remunerativo && value.remunerativo.monto != null ? parseFloat(value.remunerativo.monto).toFixed(0) : '0';
                    }
                })
                return remunerativo;
            }

            const result_noremunerativo_a = (id) => {
                var noremunerativo = "";
                $.each(costox_a, function(clave, value) {

                    if (clave == id) {

                        if (value.no_remunerativo!=null) {

                        noremunerativo = parseFloat(value.no_remunerativo.monto).toFixed(0);

                        }
                    }
                })
                return noremunerativo;
            }

            const result_total_a = (id) => {
                var costo_laboral = "";
                $.each(costox_a, function(clave, value) {

                    if (clave == id) {

                        if (value.costo_laboral!=null) {

                        costo_laboral = parseFloat(value.costo_laboral.monto).toFixed(0);

                        }
                    }
                })
                return costo_laboral;
            }

            

            const result_remunerativo_b = (id) => {
                var remunerativo = "";
                $.each(costox_b, function(clave, value) {

                    if (clave == id) {
                        remunerativo = value.remunerativo && value.remunerativo.monto != null ? parseFloat(value.remunerativo.monto).toFixed(0) : '0';
                    }
                })
                return remunerativo;
            }

            const result_noremunerativo_b = (id) => {
                var noremunerativo = "";
                $.each(costox_b, function(clave, value) {

                    if (clave == id) {

                        if (value.no_remunerativo!=null) {

                        noremunerativo = parseFloat(value.no_remunerativo.monto).toFixed(0);

                        }
                    }
                })
                return noremunerativo;
            }

            const result_total_b = (id) => {
                var costo_laboral = "";
                $.each(costox_b, function(clave, value) {

                    if (clave == id) {

                        if (value.costo_laboral!=null) {

                        costo_laboral = value.costo_laboral && value.costo_laboral.monto != null ? parseFloat(value.costo_laboral.monto).toFixed(0) : '0';

                        }
                    }
                })
                return costo_laboral;
            }



            const basico_a = (id) => {
                var basico = "";
                $.each(costox_a, function(clave, value) {
                    if (clave == id) {
                        basico = obtenerBasicoSeguro(value).toFixed(0);
                    }
                })
                return basico;
            }





            const basico_b = (id) => {
                var basico = "";
                $.each(costox_b, function(clave, value) {
                   if (clave == id) {
                        basico = obtenerBasicoSeguro(value).toFixed(0);
                    }
                })
                return basico;
            }







const proyeccion_x = (id)=>{


/* CAPTURAR LOS LEGAJOS E IMPRIMIR LOS GUARDADOS */

var p_x=0;

        
       

                $.each(datos_guardados,function(clave,valor){

                    $.each(valor,function(key,val){
                        var label = key.split("-");
                        
                            if (label[1]==id) {
                                if (label[0]=="proyeccion") {
                                    p_x=val
                                }
                            }

                            /*if (label[0]=="totalx") {
                                $("#diferencia-"+label[1]).html(val)
                            }

                            if (label[0]=="porcentaje") {
                                $("#basico_b-"+label[1]).val(val)
                            }*/
                            
                           
                            
                        
                    });
                });
            
                   console.log(p_x)
                return p_x;
        

/* CIERRA CAPTURAR LOS LEGAJOS E IMPRIMIR LOS GUARDADOS */




}


const total_x = (id)=>{


/* CAPTURAR LOS LEGAJOS E IMPRIMIR LOS GUARDADOS */

                var t_x=0;

        
       

                $.each(datos_guardados,function(clave,valor){

                    $.each(valor,function(key,val){
                        var label = key.split("-");
                        
                            if (label[1]==id) {
                                if (label[0]=="totalx") {
                                    t_x=val
                                }
                            }

                            /*
                            if (label[0]=="porcentaje") {
                                $("#basico_b-"+label[1]).val(val)
                            }*/
                            
                           
                            
                        
                    });
                });
            
                   
                return t_x;
        

/* CIERRA CAPTURAR LOS LEGAJOS E IMPRIMIR LOS GUARDADOS */




}



const porcentaje_x = (id)=>{


/* CAPTURAR LOS LEGAJOS E IMPRIMIR LOS GUARDADOS */

var p_x=0;

        
       

                $.each(datos_guardados,function(clave,valor){

                    $.each(valor,function(key,val){
                        var label = key.split("-");
                        
                            if (label[1]==id) {
                                if (label[0]=="porcentaje") {
                                    p_x=val
                                }
                            }

                            /*
                            if (label[0]=="porcentaje") {
                                $("#basico_b-"+label[1]).val(val)
                            }*/
                            
                           
                            
                        
                    });
                });
            
                   
                return p_x;
        

/* CIERRA CAPTURAR LOS LEGAJOS E IMPRIMIR LOS GUARDADOS */




}



            const egreso = (id) => {
                var egreso = "";
                $.each(personal.data, function(clave, value) {

                    if (value.leg_numero == id) {
                        
                        egreso = value.leg_fecegr;
                        
                    
                    }
                })
                return egreso;
            }


             const getDni = (id) => {
                var docu = "";
                $.each(personal.data, function(clave, value) {

                    if (value.leg_numero == id) {
                        
                        docu = value.leg_numdoc;
                        
                    
                    }
                })
                return docu;
            }



            const legal = (id) => {
                var legale = false;
                $.each(legales.data, function(clave, value) {

                    if (clave == getDni(id)) {
                        
                        legale = true;
                        
                    
                    }
                })
                return legale;
            }


const edito = (id,columna,datos) => {
    var liqui=liq_1_a+'-'+liq_1_b; 
    var status = [];
    var count=0;
    try {
        $.each(proyeccion, function (key, valor) {
            $.each(valor, function (clave, value) {
                if (parseFloat(value.legajo) === parseFloat(id)) {

                    if (parseFloat(value.columna) === parseFloat(columna)) {
                        count++;

                        status.push({
                            "editor": value.editor,
                            "legajo": value.legajo,
                            "nuevoValor": value.nuevoValor,
                            "fecha": value.fecha,
                            "porcentaje": value.porcentaje,
                            "clave":count,
                            "audita":'<span style="background-color: #073f00;padding: 4px;color: #fff;font-size: 8px;font-weight: bold;">'+value.editor+' </span> <span style="font-size: 10px;color:black;">'+value.fecha+'</span><a href="#" data-liquidacion='+liqui+'>+</a>'
                        });

                    }
                }
            });
        });
        
        
        
        
    } catch (error) {

        if (status.length==0) {
            count++;
             status.push({
                            "editor": '',
                            "legajo": id,
                            "nuevoValor": datos,
                            "fecha": '',
                            "porcentaje": '',
                            "clave":'',
                            "audita":''
                        });
            
        }


         if (status.length>1) {
            return status[status.length-1];
        }else{
            return status[0];
        }
    }
};


const historico = (id) => {
    var liqui=liq_1_a+'-'+liq_1_b; 
    var status = [];
    var count=0;
    try {
        $.each(proyeccion, function (key, valor) {
            $.each(valor, function (clave, value) {
                if (parseFloat(value.legajo) === parseFloat(id)) {

                        count++;

                        status.push({
                            "editor": value.editor,
                            "legajo": value.legajo,
                            "nuevoValor": value.nuevoValor,
                            "fecha": value.fecha,
                            "porcentaje": value.porcentaje,
                            "mes": value.mes,
                            "clave":count,
                            "audita":'<span style="background-color: #073f00;padding: 4px;color: #fff;font-size: 8px;font-weight: bold;">'+value.editor+' </span> <span style="font-size: 10px;color:black;">'+value.fecha+'</span><a href="#" data-liquidacion='+liqui+'>+</a>'
                        });

                    }
                
            });
        });
        
        
         return status;
        
    } catch (error) {

       

        return status;
    }
};



const ajuste_salarial = (id) => {
    var liqui=liq_1_a+'-'+liq_1_b; 
    var status = [];
    var count=0;
    try {
        $.each(ajustes.data, function (key, value) {
           
               
                if (parseFloat(value.legajo) === parseFloat(id)) {

                        count++;

                        status.push({
                            "editor": value.editor,
                            "legajo": value.legajo,
                            "nuevoValor": value.nuevoValor,
                            "fecha": value.fecha,
                            "porcentaje": value.porcentaje,
                            "mes": value.mes,
                            "clave":count,
                            "comentario":value.comentario
                        });

                    }
                
            
        });
        
        
         return status;
        
    } catch (error) {

       

        return status;
    }
};


    const result_ajuste = (legajo,mes,basico) => {
                var ajuste = basico;
                $.each(ajuste_requi.data, function(clave, value) {

                    if (value.legajo == legajo) {

                        if (value.mes_ajuste == mes) {

                            if (value.statusDirectorio == 1) {

                                    ajuste = value.salario_nuevo;

                             }

                        }
                    }
                })
                return ajuste;
            }



 const result_info = (legajo,mes) => {
                var info = 0;
                $.each(ajuste_requi.data, function(clave, value) {

                    if (value.legajo == legajo) {

                        if (value.mes_ajuste == mes) {

                            if (value.statusDirectorio == 1) {

                                    info = parseFloat(value.salario_nuevo);

                             }

                        }
                    }
                })
                return info;
            }



             const result_info_comentario = (legajo,mes,basico) => {
                var info = 0;
                $.each(ajuste_requi.data, function(clave, value) {

                    if (value.legajo == legajo) {

                        if (value.mes_ajuste == mes) {

                            if (value.statusDirectorio == 1) {

                                var valorInicial = parseFloat(basico.replace(/[$.,]/g, ""));
                                var valorFinal = parseFloat(value.salario_nuevo);

                                console.log(valorInicial)
                                console.log(parseFloat(value.salario_nuevo))

                                // Calcula la diferencia entre el valor final y el valor inicial
                                var diferencia = valorFinal - valorInicial;

                                // Calcula el porcentaje necesario para alcanzar la diferencia
                                var porcentaje = (diferencia / valorInicial) * 100;

                                console.log("Debes agregar un " + porcentaje.toFixed(2) + "% al valor inicial para llegar a " + valorFinal+"Motivo: "+value.motivo);


                                    info = "Debes agregar un " + porcentaje.toFixed(2) + "% al valor inicial para llegar a " + valorFinal+"Motivo: "+value.motivo;

                             }

                        }
                    }
                })
                return info;
            }
            
            

            
            var lista = []; 
            var guardado = [];    
             // abre liquidacion 1



// Objeto que mapea nombres de meses en español a inglés
var mesesTraduccion = {
  'Enero': 'January',
  'Febrero': 'February',
  'Marzo': 'March',
  'Abril': 'April',
  'Mayo': 'May',
  'Junio': 'June',
  'Julio': 'July',
  'Agosto': 'August',
  'Septiembre': 'September',
  'Octubre': 'October',
  'Noviembre': 'November',
  'Diciembre': 'December'
};

// Nombre del mes en español
var mesEnEspanol = 'agosto';

// Traducir el nombre del mes al inglés
var mesEnIngles = mesesTraduccion[mesEnEspanol];

console.log(mesEnIngles); // Esto mostrará "August"

var mes_parse = $("#liquidacion-a option:selected").text().split(" ");
var mes_original=mesesTraduccion[mes_parse[0]];
var anio_original=mes_parse[1];
var liqui_data=mes_original+" "+anio_original

// Fecha inicial
    const fechaInicial = new Date(liqui_data);
console.log($("#liquidacion-a option:selected").text())
// Nombres de meses abreviados
    const mesesAbreviados = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

    // Crear un array para almacenar las fechas
    const fechasSiguientes = [];
    const fechasSiguientes_b = [];

    // Generar las siguientes 4 fechas
    for (let i = 0; i < 5; i++) {
      const fechaSiguiente = new Date(fechaInicial);
      fechaSiguiente.setMonth(fechaInicial.getMonth() + i);
      const mesAbreviado = mesesAbreviados[fechaSiguiente.getMonth()];
      const año = fechaSiguiente.getFullYear();
      fechasSiguientes.push(`${mesAbreviado} ${año}`);
      fechasSiguientes_b.push(mesAbreviado+' de '+año);
      console.log(fechaSiguiente.getMonth())
    }



            $.each(costox_a, function(clave, valor) {



var basico = result_ajuste(clave,$("#liquidacion-a option:selected").text(),basico_a(clave));



                    
                    var p_total = (basico_b(clave)-basico)*100/basico;

                    if (p_total==Infinity) {
                         p_total = (basico-basico_b(clave))*100/basico_b(clave);
                    }

               
                    var convenio = "FUERA DE CONVENIO";
                    if (convencionado(clave)==1) {
                        convenio = "CCT";
                    }

                    sessionStorage.removeItem("total-"+clave)

                       



var editor = "";


if (edito(clave,3,basico).audita!="") {

   editor=edito(clave,3,basico).audita;

}

if (edito(clave,5,basico).audita!="") {

   editor=edito(clave,5,basico).audita;

}

if (edito(clave,7,basico).audita!="") {

   editor=edito(clave,7,basico).audita;

}

if (edito(clave,9,basico).audita!="") {

   editor=edito(clave,9,basico).audita;

}


var porcentaje_suma = [];
var liqui=liq_1_a+'-'+liq_1_b; 

guardado.push(historico(clave))

var pv3=0;
var pv5=0;
var pv7=0;
var pv9=0;

if (parseFloat(edito(clave,3,basico).porcentaje.replace(/[^0-9.-]/g, ''))>0) {
    
    pv3=parseFloat(edito(clave,3,basico).porcentaje.replace(/[^0-9.-]/g, ''));

}
if (parseFloat(edito(clave,5,basico).porcentaje.replace(/[^0-9.-]/g, ''))>0) {
    pv5=parseFloat(edito(clave,5,basico).porcentaje.replace(/[^0-9.-]/g, ''));
}
if (parseFloat(edito(clave,7,basico).porcentaje.replace(/[^0-9.-]/g, ''))>0) {
    pv7=parseFloat(edito(clave,7,basico).porcentaje.replace(/[^0-9.-]/g, ''));
}
if (parseFloat(edito(clave,9,basico).porcentaje.replace(/[^0-9.-]/g, ''))>0) {
    pv9=parseFloat(edito(clave,9,basico).porcentaje.replace(/[^0-9.-]/g, ''));
}


                        
                        porcentaje_suma=[
                            pv3,
                            pv5+pv3,
                            pv7+pv5+pv3,
                            pv9+pv7+pv5+pv3
                        ];


                        var pvc3=0;
                        var pvc5=0;
                        var pvc7=0;
                        var pvc9=0;

                        if (parseFloat(edito(clave,3,basico).porcentaje.replace(/[^0-9.-]/g, ''))>0) {
                            pvc3=parseFloat(edito(clave,3,basico).porcentaje.replace(/[^0-9.-]/g, ''));
                        }
                        if (parseFloat(edito(clave,5,basico).porcentaje.replace(/[^0-9.-]/g, ''))>0) {
                            pvc5=parseFloat(edito(clave,5,basico).porcentaje.replace(/[^0-9.-]/g, ''));
                        }
                        if (parseFloat(edito(clave,7,basico).porcentaje.replace(/[^0-9.-]/g, ''))>0) {
                            pvc7=parseFloat(edito(clave,7,basico).porcentaje.replace(/[^0-9.-]/g, ''));
                        }
                        if (parseFloat(edito(clave,9,basico).porcentaje.replace(/[^0-9.-]/g, ''))>0) {
                            pvc9=parseFloat(edito(clave,9,basico).porcentaje.replace(/[^0-9.-]/g, ''));
                        }


                        var contable_id="";
                        var contable_desc="";
                        if (localStorage.getItem("ubicacion-"+clave)=="029081515"||localStorage.getItem("ubicacion-"+clave)=="033503144"||localStorage.getItem("ubicacion-"+clave)=="033503155"||localStorage.getItem("ubicacion-"+clave)=="033503166"||localStorage.getItem("ubicacion-"+clave)=="033503177"||localStorage.getItem("ubicacion-"+clave)=="67"||localStorage.getItem("ubicacion-"+clave)=="68"||localStorage.getItem("ubicacion-"+clave)=="69"||localStorage.getItem("ubicacion-"+clave)=="70"||localStorage.getItem("ubicacion-"+clave)=="71"||localStorage.getItem("ubicacion-"+clave)=="75"||localStorage.getItem("ubicacion-"+clave)=="999992"||localStorage.getItem("ubicacion-"+clave)=="999993"||localStorage.getItem("ubicacion-"+clave)=="999999") {
                            contable_id=1;
                            contable_desc="Producción";
                        }else if (localStorage.getItem("ubicacion-"+clave)=="0335029"||localStorage.getItem("ubicacion-"+clave)=="1001") {
                            contable_id=2;
                            contable_desc="Comercialización";
                        }else if (localStorage.getItem("ubicacion-"+clave)=="000558"||localStorage.getItem("ubicacion-"+clave)=="000553"||localStorage.getItem("ubicacion-"+clave)=="000555"||localStorage.getItem("ubicacion-"+clave)=="001016"||localStorage.getItem("ubicacion-"+clave)=="010101999"||localStorage.getItem("ubicacion-"+clave)=="0335030"||localStorage.getItem("ubicacion-"+clave)=="0335031"||localStorage.getItem("ubicacion-"+clave)=="033503188"||localStorage.getItem("ubicacion-"+clave)=="033503199"||localStorage.getItem("ubicacion-"+clave)=="033503200"||localStorage.getItem("ubicacion-"+clave)=="033503201"||localStorage.getItem("ubicacion-"+clave)=="095447887"||localStorage.getItem("ubicacion-"+clave)=="100111928992"||localStorage.getItem("ubicacion-"+clave)=="1002"||localStorage.getItem("ubicacion-"+clave)=="1003"||localStorage.getItem("ubicacion-"+clave)=="1004"||localStorage.getItem("ubicacion-"+clave)=="1005"||localStorage.getItem("ubicacion-"+clave)=="1006"||localStorage.getItem("ubicacion-"+clave)=="1007"||localStorage.getItem("ubicacion-"+clave)=="1008"||localStorage.getItem("ubicacion-"+clave)=="1009"||localStorage.getItem("ubicacion-"+clave)=="1010"||localStorage.getItem("ubicacion-"+clave)=="1011"||localStorage.getItem("ubicacion-"+clave)=="1012"||localStorage.getItem("ubicacion-"+clave)=="1014"||localStorage.getItem("ubicacion-"+clave)=="67"||localStorage.getItem("ubicacion-"+clave)=="70"||localStorage.getItem("ubicacion-"+clave)=="71"||localStorage.getItem("ubicacion-"+clave)=="75"||localStorage.getItem("ubicacion-"+clave)=="100112"||localStorage.getItem("ubicacion-"+clave)=="000559"||localStorage.getItem("ubicacion-"+clave)=="000544"||localStorage.getItem("ubicacion-"+clave)=="000554"||localStorage.getItem("ubicacion-"+clave)=="000564"||localStorage.getItem("ubicacion-"+clave)=="100111"||localStorage.getItem("ubicacion-"+clave)=="100111928992") {
                            contable_id=4;
                            contable_desc="Administración";
                        }else{
                            contable_id=3;
                            contable_desc="Operación";
                        }


                        

                        if (convencionado(clave)==0) {

                            if(egreso(clave)==undefined){

                                if(legal(clave)==false){

var comentario = "";

if (ajuste_salarial(clave).length>0) {
    comentario = "hola";
}

// result_ajuste(legajo,mes)
//$("#liquidacion-a option:selected").text()







                                    const datosCostoActual = obtenerDatosCostoSeguro(valor);
                                    const catTipo = datosCostoActual.cat_tipo != null ? datosCostoActual.cat_tipo : 'SIN-CAT';
                                    const nombreRegistro = obtenerNombreRegistroSeguro(valor, clave);
                                    const partesNombre = nombreRegistro.split(', ');
                                    const nombreMostrado = partesNombre.length >= 2
                                        ? (partesNombre[0] + ' ' + partesNombre.slice(1).join(' ')).trim()
                                        : nombreRegistro;

                                    var catego="";

                                    if (clave>1000) {
                                         catego = result_categoria(catTipo)+" - "+catTipo;
                                    }else{
                                        catego = result_categoria_cat(catTipo)+" - "+catTipo;
                                    }

                                    lista.push([
                                        '<div class="categoria-'+catTipo+'">'+clave+'</div>',
                                        nombreMostrado+'<br><span style="background-color: transparent;padding: 4px;color: #000;font-size: 8px;">'+catego+'</span><br><span style="background-color: transparent;padding: 4px;color: #000;font-size: 8px;margin-left:0px;">'+localStorage.getItem("operacion-"+localStorage.getItem("ubicacion-"+clave))+'<br>'+contable_desc+'</span>',
                                        basico,
                                        pvc3,
                                        parseFloat(basico)+(parseFloat(basico)*porcentaje_suma[0])/100,
                                        pvc5,
                                        parseFloat(basico)+(parseFloat(basico)*porcentaje_suma[1])/100,
                                        pvc7,
                                        parseFloat(basico)+(parseFloat(basico)*porcentaje_suma[2])/100,
                                        pvc9,
                                        parseFloat(basico)+(parseFloat(basico)*porcentaje_suma[3])/100,

                                       editor
                                       ]
                                    )
                                }
                            }
                        }


                    
                    

 

                       
$("#mas-"+liqui+"-"+clave).click(function(){
    console.log("data click")
})
                


            });

            // cierra liquidacion 1

          
           localStorage.setItem("editados",JSON.stringify(guardado))


         



//////////////////////////////////////////////


const formatCurrency = (amount) => {
      return "$" + Math.round(vm.limpiarNumero(amount)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

let actualizandoTablaInternamente = false;
let timerCambioPendienteProyeccion = null;
let ultimoCambioProyeccion = null;

const obtenerLegajoFila = (sheet, rowIndex) => {
      let valor = '';
      try {
        if (sheet && sheet.options && Array.isArray(sheet.options.data) && sheet.options.data[rowIndex]) {
          valor = sheet.options.data[rowIndex][0];
        }
      } catch (e) {
        /* fallback */
      }

      if ((valor == null || valor === '') && sheet && typeof sheet.getValueFromCoords === 'function') {
        try {
          valor = sheet.getValueFromCoords(0, rowIndex);
        } catch (e) {
          valor = '';
        }
      }

      return String(valor || '').replace(/<[^>]*>/g, '').replace(/[^0-9.-]/g, '').trim();
    };

const columnasPorcentaje = [3,5,7,9];
const columnasResultadoMap = { 3: 4, 5: 6, 7: 8, 9: 10 };
const columnasMesMap = { 3: 1, 5: 2, 7: 3, 9: 4 };

const obtenerNombreUsuarioLogueado = () => {
      let userData = {};
      try {
        userData = JSON.parse(sessionStorage.getItem('userData') || '{}') || {};
      } catch (e) {
        userData = {};
      }

      const candidatos = [
        userData.nombre_completo,
        userData.nombreCompleto,
        userData.fullName,
        userData.name,
        [userData.leg_nombre, userData.leg_apellido].filter(Boolean).join(' '),
        [userData.leg_apellido, userData.leg_nombre].filter(Boolean).join(' '),
        localStorage.getItem('editor') || ''
      ].map(v => String(v || '').replace(/\s+/g, ' ').trim()).filter(Boolean);

      return candidatos[0] || 'Sistema';
    };

const obtenerFechaHoraAuditoria = () => {
      const fechaHoraActual = new Date();
      const dia = fechaHoraActual.getDate().toString().padStart(2, '0');
      const mes = (fechaHoraActual.getMonth() + 1).toString().padStart(2, '0');
      const anio = fechaHoraActual.getFullYear();
      const hora = fechaHoraActual.getHours().toString().padStart(2, '0');
      const minutos = fechaHoraActual.getMinutes().toString().padStart(2, '0');
      const segundos = fechaHoraActual.getSeconds().toString().padStart(2, '0');
      return anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos + ':' + segundos;
    };

const construirHtmlAuditoria = (registro) => {
      return '<span style="background-color: #073f00;padding: 4px;color: #fff;font-size: 8px;font-weight: bold;">'
        + (registro.editor || 'Sistema')
        + ' </span> <span style="font-size: 10px;color:black;">'
        + (registro.fecha || '')
        + '</span> <span style="display:inline-block;margin-left:6px;background:#1976d2;color:#fff;border-radius:10px;padding:1px 7px;font-size:11px;font-weight:bold;line-height:1.4;cursor:pointer;">+</span>';
    };

const actualizarHistorialLocal = (legajo, registro) => {
      let editados = [];
      try {
        editados = JSON.parse(localStorage.getItem('editados') || '[]');
        if (!Array.isArray(editados)) {
          editados = [];
        }
      } catch (e) {
        editados = [];
      }

      const itemHistorial = {
        editor: registro.editor,
        legajo: registro.legajo,
        nuevoValor: registro.nuevoValor,
        fecha: registro.fecha,
        porcentaje: registro.porcentaje,
        mes: registro.mes,
        columna: registro.columna,
        celda: registro.celda,
        audita: construirHtmlAuditoria(registro)
      };

      let indiceGrupo = -1;
      for (let i = 0; i < editados.length; i++) {
        if (Array.isArray(editados[i]) && editados[i].some(item => String(item.legajo) === String(legajo))) {
          indiceGrupo = i;
          break;
        }
      }

      if (indiceGrupo === -1) {
        editados.push([itemHistorial]);
      } else {
        editados[indiceGrupo].push(itemHistorial);
      }

      localStorage.setItem('editados', JSON.stringify(editados));
    };

const obtenerValorCeldaSeguro = (sheet, col, rowIndex) => {
      try {
        if (sheet && sheet.options && Array.isArray(sheet.options.data) && sheet.options.data[rowIndex]) {
          return sheet.options.data[rowIndex][col];
        }
      } catch (e) {
        /* fallback: intentar siguiente fuente de datos */
      }

      try {
        if (sheet && typeof sheet.getValueFromCoords === 'function') {
          return sheet.getValueFromCoords(col, rowIndex);
        }
      } catch (e) {
        /* fallback final: devolver vacío */
      }

      return '';
    };

const pintarCeldaSegura = (sheet, col, rowIndex, value, tipo = 'text') => {
      if (!sheet) {
        return;
      }

      if (sheet.options && Array.isArray(sheet.options.data) && sheet.options.data[rowIndex]) {
        sheet.options.data[rowIndex][col] = value;
      }

      const celda = sheet.records && sheet.records[rowIndex] && sheet.records[rowIndex][col]
        ? sheet.records[rowIndex][col]
        : null;

      if (!celda) {
        return;
      }

      if (tipo === 'html') {
        celda.innerHTML = value == null ? '' : String(value);
        return;
      }

      if (tipo === 'currency') {
        const numero = vm.limpiarNumero(value);
        celda.innerHTML = formatCurrency(Math.round(numero));
        return;
      }

      celda.innerHTML = value == null ? '' : String(value);
    };

const actualizarAuditoriaFila = (sheet, rowIndex, registro) => {
      actualizandoTablaInternamente = true;
      try {
        pintarCeldaSegura(sheet, 11, rowIndex, construirHtmlAuditoria(registro), 'html');
      } finally {
        actualizandoTablaInternamente = false;
      }
    };

const persistirProyeccion = (registro) => {
      return firedata.database().ref('proyecciones/' + registro.liquidacion).push(registro)
        .then((savedRef) => {
          if (proyeccion && typeof proyeccion === 'object' && savedRef && savedRef.key) {
            proyeccion[savedRef.key] = registro;
          }
          return registro;
        });
    };

const formatearPorcentajeAuditoria = (valor) => {
      const texto = String(valor == null ? '' : valor).trim().replace(',', '.');
      if (!texto) {
        return '% 0';
      }
      const numero = vm.limpiarNumero(texto);
      return '% ' + String(Number.isFinite(numero) ? numero : 0);
    };

const recalcularFilaProyeccion = (sheet, rowIndex, porcentajesOverride = {}) => {
      const base = vm.limpiarNumero(obtenerValorCeldaSeguro(sheet, 2, rowIndex));
      const tieneOverride = Object.prototype.hasOwnProperty.bind(porcentajesOverride);
      const p1 = vm.limpiarNumero(tieneOverride(3) ? porcentajesOverride[3] : obtenerValorCeldaSeguro(sheet, 3, rowIndex));
      const p2 = vm.limpiarNumero(tieneOverride(5) ? porcentajesOverride[5] : obtenerValorCeldaSeguro(sheet, 5, rowIndex));
      const p3 = vm.limpiarNumero(tieneOverride(7) ? porcentajesOverride[7] : obtenerValorCeldaSeguro(sheet, 7, rowIndex));
      const p4 = vm.limpiarNumero(tieneOverride(9) ? porcentajesOverride[9] : obtenerValorCeldaSeguro(sheet, 9, rowIndex));

      const aplicarAumento = (valor, porcentaje) => {
        return Math.round((valor * (1 + (porcentaje / 100))) * 100) / 100;
      };

      const r1 = aplicarAumento(base, p1);
      const r2 = aplicarAumento(r1, p2);
      const r3 = aplicarAumento(r2, p3);
      const r4 = aplicarAumento(r3, p4);

      actualizandoTablaInternamente = true;
      try {
        pintarCeldaSegura(sheet, 4, rowIndex, r1, 'currency');
        pintarCeldaSegura(sheet, 6, rowIndex, r2, 'currency');
        pintarCeldaSegura(sheet, 8, rowIndex, r3, 'currency');
        pintarCeldaSegura(sheet, 10, rowIndex, r4, 'currency');
      } finally {
        actualizandoTablaInternamente = false;
      }

      return {
        base,
        porcentajes: { 3: p1, 5: p2, 7: p3, 9: p4 },
        resultados: { 4: r1, 6: r2, 8: r3, 10: r4 }
      };
    };

const actualizarFootersProyeccion = (sheet) => {
      const filas = sheet && sheet.options && Array.isArray(sheet.options.data) ? sheet.options.data.length : 0;
      let sumaBase = 0;
      let suma4 = 0;
      let suma6 = 0;
      let suma8 = 0;
      let suma10 = 0;

      for (let i = 0; i < filas; i++) {
        sumaBase += vm.limpiarNumero(obtenerValorCeldaSeguro(sheet, 2, i));
        suma4 += vm.limpiarNumero(obtenerValorCeldaSeguro(sheet, 4, i));
        suma6 += vm.limpiarNumero(obtenerValorCeldaSeguro(sheet, 6, i));
        suma8 += vm.limpiarNumero(obtenerValorCeldaSeguro(sheet, 8, i));
        suma10 += vm.limpiarNumero(obtenerValorCeldaSeguro(sheet, 10, i));
      }

      $(".jexcel > tfoot > tr > td:nth-child(4)").html(formatCurrency(sumaBase));
      $(".jexcel > tfoot > tr > td:nth-child(6)").html(formatCurrency(suma4));
      $(".jexcel > tfoot > tr > td:nth-child(8)").html(formatCurrency(suma6));
      $(".jexcel > tfoot > tr > td:nth-child(10)").html(formatCurrency(suma8));
      $(".jexcel > tfoot > tr > td:nth-child(12)").html(formatCurrency(suma10));
    };

const procesarCambioEdicionProyeccion = (columnaEditada, filaEditada, valorNuevo) => {
      if (!table) {
        return;
      }

      const col = parseInt(columnaEditada);
      const row = parseInt(filaEditada);
      if (Number.isNaN(col) || Number.isNaN(row) || columnasPorcentaje.indexOf(col) === -1) {
        return;
      }

      const porcentajeNormalizado = vm.limpiarNumero(valorNuevo);

      actualizandoTablaInternamente = true;
      try {
        if (table && table.options && Array.isArray(table.options.data) && table.options.data[row]) {
          table.options.data[row][col] = porcentajeNormalizado;
        }

        recalcularFilaProyeccion(table, row);
        actualizarFootersProyeccion(table);
        setTimeout(function() {
          actualizarFootersProyeccion(table);
        }, 0);

        const legajo = obtenerLegajoFila(table, row);
        if (!legajo) {
          return;
        }

        const liquidacion = liq_1_a + '-' + liq_1_b;
        const editor = obtenerNombreUsuarioLogueado();
        const fechaHoraFormateada = obtenerFechaHoraAuditoria();
        const mesIndex = columnasMesMap[col];

        const registroGuardado = {
          liquidacion: String(liquidacion || ''),
          editor: String(editor || ''),
          nuevoValor: '0',
          porcentaje: formatearPorcentajeAuditoria(porcentajeNormalizado),
          legajo: String(legajo || ''),
          fecha: String(fechaHoraFormateada || ''),
          columna: String(col),
          celda: String(row),
          mes: String(fechasSiguientes[mesIndex] || '')
        };

        actualizarAuditoriaFila(table, row, registroGuardado);
        actualizarHistorialLocal(legajo, registroGuardado);

        persistirProyeccion(registroGuardado)
          .then(() => {
            console.log('datos guardados');
          })
          .catch(e => {
            console.log(e);
          });
      } finally {
        actualizandoTablaInternamente = false;
      }
    };


var data = lista;

console.log(lista.length)
this.mostrarBotonAjustes = true;
$("#loading").hide();





var table =jspreadsheet(document.getElementById('spreadsheet'), {
   
    data:data,
    search: true,
    pagination: 10,
    setEditable:false,
    columnSorting:false,
   
    
    paginationOptions: [10,25,50],
    filters: false,
     allowComments:true,
     tabs:[
    {
        sheetName: 'Countries',
        minDimensions:[10,10]
    },
    {
        sheetName: 'Cities',
        minDimensions:[10,10]
    }
],
    
     footers: [[
        'Total',
        '',
        '=ROUND(SUM(C1:C'+lista.length+'),0)',
        '',
        '=ROUND(SUM(E1:E'+lista.length+'),0)',
        '',
        '=ROUND(SUM(G1:G'+lista.length+'),0)',
        '',
        '=ROUND(SUM(I1:I'+lista.length+'),0)',
        '',
        '=ROUND(SUM(K1:K'+lista.length+'),0)',
        ''
        ]],
      onload: function(el, value, column, record, cell, rowIndex) {

const calcularDiferenciaMeses=(fecha1, fecha2) => {
 // Definimos un objeto que mapea nombres de meses a números
  const meses = {
    Enero: 0, Febrero: 1, Marzo: 2, Abril: 3, Mayo: 4, Junio: 5,
    Julio: 6, Agosto: 7, Septiembre: 8, Octubre: 9, Noviembre: 10, Diciembre: 11
  };

  const meses_b = {
    enero: 0, febrero: 1, marzo: 2, abril: 3, mayo: 4, junio: 5,
    julio: 6, agosto: 7, septiembre: 8, octubre: 9, noviembre: 10, diciembre: 11
  };

  // Dividimos las cadenas en mes y año
  const [mes1, año1] = fecha1.split(' ');
  const [mes2, año2] = fecha2.split(' de ');

  // Creamos objetos de fecha con el mes y año
  const fechaInicio = new Date(año1, meses[mes1]);
  const fechaFin = new Date(año2, meses_b[mes2]);

  // Calculamos la diferencia en meses
  const diferenciaEnMilisegundos = fechaFin - fechaInicio;

  // Convertimos la diferencia en meses
  const mesesDeDiferencia = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24 * 30.44); // Promedio de días por mes

  return Math.round(mesesDeDiferencia);
}






 setTimeout(function(){

         for (var i = 0; i < value.records.length; i++) {

            for (var e = 1; e < fechasSiguientes_b.length; e++) {

               
               

               
               

                var informacion_3 = '';
                if (result_info($(value.records[i][0]).text(),fechasSiguientes_b[e])!=0) {
                   
                    var mes_inicio=$("#liquidacion-a option:selected").text();
                    var mes_final=fechasSiguientes_b[e];
                    var diferencia = calcularDiferenciaMeses(mes_inicio, mes_final);
                    var med_id=0;
                    var letra="";

                    if (diferencia==0) {
                        med_id=2;
                        letra="C";
                    }

                    if (diferencia==1) {
                        med_id=4;
                        letra="E";
                    }

                    if (diferencia==2) {
                        med_id=6;
                        letra="G";
                    }
                    if (diferencia==3) {
                        med_id=8;
                        letra="I";
                    }
                    if (diferencia==4) {
                        med_id=10;
                        letra="K";
                    }


                    informacion_3 = '<span class="globo">!</span>';
                     console.log("diferencia de meses: "+diferencia)
                     console.log(fechasSiguientes_b[e])
                     console.log($(value.records[i][0]).text())
                     console.log(result_info($(value.records[i][0]).text(),fechasSiguientes_b[e]))
                     console.log(value.records[i][med_id].dataset.x)
                     console.log(value.records[i][med_id].dataset.y)
                     var numero = parseFloat(value.records[i][med_id].dataset.y)+1;
                     var ubicacion=letra+numero.toString();
                     console.log("REQUISITORIA")
                     console.log($(value.records[i][0]).text())
                     var comentario =result_info_comentario($(value.records[i][0]).text(),fechasSiguientes_b[e],$(value.records[i][2]).text());
                       
                      
                         console.log(ubicacion)
                        table.setComments(ubicacion, comentario,"comentario");
                      
                     console.log("----------------------------------------------------")

                }
            }

           
         }

          },3000)

        
      },

     onbeforechange: function(instance, cell, x, y, value) {
            if (actualizandoTablaInternamente) {
                return value;
            }

            const columnaEditada = parseInt(x);
            const filaEditada = parseInt(y);
            if (columnasPorcentaje.indexOf(columnaEditada) === -1) {
                return value;
            }

            const valorNormalizado = vm.limpiarNumero(value);
            ultimoCambioProyeccion = {
                x: columnaEditada,
                y: filaEditada,
                value: valorNormalizado
            };

            return valorNormalizado;
    },
    oncreateeditor: function(instance, cell, x, y, editor) {
            const columnaEditada = parseInt(x);
            const filaEditada = parseInt(y);
            if (columnasPorcentaje.indexOf(columnaEditada) === -1) {
                return;
            }

            const input = editor && (editor.tagName === 'INPUT' || editor.tagName === 'TEXTAREA')
                ? editor
                : (editor && editor.querySelector ? editor.querySelector('input, textarea') : null);

            if (!input) {
                return;
            }

            const previsualizar = function() {
                if (!table || actualizandoTablaInternamente) {
                    return;
                }

                const valorTemporal = vm.limpiarNumero(input.value);
                const override = {};
                override[columnaEditada] = valorTemporal;

                recalcularFilaProyeccion(table, filaEditada, override);
                actualizarFootersProyeccion(table);
            };

            input.addEventListener('input', previsualizar);
            input.addEventListener('keyup', previsualizar);
    },
    onchange: function(instance, cell, x, y, value, oldValue) {
            if (actualizandoTablaInternamente) {
                return;
            }

            const columnaEditada = parseInt(x);
            const filaEditada = parseInt(y);
            if (columnasPorcentaje.indexOf(columnaEditada) === -1) {
                return;
            }

            let valorFinal = vm.limpiarNumero(value);
            if (
                ultimoCambioProyeccion &&
                parseInt(ultimoCambioProyeccion.x) === columnaEditada &&
                parseInt(ultimoCambioProyeccion.y) === filaEditada
            ) {
                valorFinal = vm.limpiarNumero(ultimoCambioProyeccion.value);
            }

            if (timerCambioPendienteProyeccion) {
                clearTimeout(timerCambioPendienteProyeccion);
            }

            timerCambioPendienteProyeccion = setTimeout(function() {
                procesarCambioEdicionProyeccion(columnaEditada, filaEditada, valorFinal);
                ultimoCambioProyeccion = null;
            }, 0);
    },
    oneditionend: function(instance, cell, x, y, newValue, save) {
            if (actualizandoTablaInternamente) {
                return;
            }

            const columnaEditada = parseInt(x);
            const filaEditada = parseInt(y);
            if (columnasPorcentaje.indexOf(columnaEditada) === -1) {
                return;
            }

            if (!save) {
                setTimeout(function() {
                    recalcularFilaProyeccion(table, filaEditada);
                    actualizarFootersProyeccion(table);
                }, 0);
            }
    },
    onselection: function(instance, x1, y1, x2, y2, origin) {
    if (parseInt(x1) !== 11) {
        return;
    }

    setTimeout(function() {
        const legajo = obtenerLegajoFila(table, y1);
        if (!legajo) {
            return;
        }

        let editados = [];
        try {
            editados = JSON.parse(localStorage.getItem('editados') || '[]');
            if (!Array.isArray(editados)) {
                editados = [];
            }
        } catch (e) {
            editados = [];
        }

        const historial = [];
        editados.forEach(function(grupo) {
            if (!Array.isArray(grupo)) {
                return;
            }
            grupo.forEach(function(item) {
                if (String(item.legajo || '') === String(legajo)) {
                    historial.push(item);
                }
            });
        });

        if (!historial.length) {
            Swal.fire({
              icon: 'info',
              title: 'Sin auditoría',
              text: 'No hay registros guardados para este legajo todavía.'
            });
            return;
        }

        historial.sort(function(a, b) {
            return String(b.fecha || '').localeCompare(String(a.fecha || ''));
        });

        let html = '<div id="historico">';
        historial.forEach(function(v) {
            const nuevoValor = Number(v.nuevoValor || 0);
            html += (v.editor || '') + '<br>'
              + (v.fecha || '') + '<br>Mes/Año:' + (v.mes || '')
              + '<br>Porcentaje:' + (v.porcentaje || '')
              + '<br>Nuevo Valor:$' + nuevoValor.toLocaleString('es-ES')
              + '<hr>';
        });
        html += '</div>';

        Swal.fire({
          icon: 'success',
          title: 'Historial de edición',
          html: html,
          footer: 'Los datos presentados son registros únicos guardados al editar una celda. Si querés visualizar la edición actual, actualizá el sitio.'
        });
    }, 0);
},




    columns: [
        {
            type: 'html',
            title:'Legajo',
            width:50,
            align:"left",
            readOnly:true
        },
        {
            type: 'html',
            title:'Nombre y Apellido',
            width:240,
            align:"left",
            readOnly:true,
        },


        {
            type: 'html',
            title:$("#liquidacion-a option:selected").text(),
            mask:'$ #.##',
            width:100,
            decimal:',',
            align:"left",
            readOnly:true
        }

        /* MES */

        ,{
            type: 'numeric',
            title:fechasSiguientes[1],
            mask:'% #.##',
            width:100,
            decimal:'.',
            align:"left",
            readOnly:false
        },


        {
            type: 'numeric',
            title:"Resultado",
            mask:'$ #.##',
            width:100,
            decimal:',',
            align:"left",
            readOnly:true
        }




       /* MES */

        ,{
            type: 'numeric',
            title:fechasSiguientes[2],
            mask:'% #.##',
            width:100,
            decimal:'.',
            align:"left",
            readOnly:false
        },


        {
            type: 'numeric',
            title:"Resultado",
            mask:'$ #.##',
            width:100,
            decimal:',',
            align:"left",
            readOnly:true
        }

       /* MES */

        ,{
            type: 'numeric',
            title:fechasSiguientes[3],
            mask:'% #.##',
            width:100,
             decimal:'.',
            align:"left",
            readOnly:false
        },


        {
            type: 'numeric',
            title:"Resultado",
            mask:'$ #.##',
            width:100,
            decimal:',',
            align:"left",
            readOnly:true
        }

        /* MES */

        ,{
            type: 'numeric',
            title:fechasSiguientes[4],
            mask:'% #.##',
            width:100,
             decimal:'.',
            align:"left",
            readOnly:false
        },


        {
            type: 'numeric',
            title:"Resultado",
            mask:'$ #.##',
            width:100,
            decimal:',',
            align:"left",
            readOnly:true
        }









        ,{
            type: 'html',
            title:'Editado',
            width:250,
            align:"left",
            readOnly:true
        }
     ]
   
});

vm.proyeccionTable = table;

setTimeout(function(){
    for (var fila = 0; fila < table.getData().length; fila++) {
        recalcularFilaProyeccion(table, fila);
    }
    actualizarFootersProyeccion(table);
}, 300);





setTimeout(function(){

    console.log("ahora si")




    $(".filtro").click(function(){

    var filtro = $(this).data("filtro");
    


    table.search(filtro);


    });

},4000)





///////////////////////////////////////////

actualizarFootersProyeccion(table);
          
//var unicos = this.removeDuplicates(lista, "legajo");


            this.personal = lista;
            $("#loading").hide();








        })).then(() => {





$("#loading").hide();
 



var footer_a=$(".jexcel > tfoot > tr > td:nth-child(4)").html().replace("$ ","");
var footer_b=$(".jexcel > tfoot > tr > td:nth-child(6)").html().replace("$ ","");
var footer_c=$(".jexcel > tfoot > tr > td:nth-child(8)").html().replace("$ ","");
var footer_d=$(".jexcel > tfoot > tr > td:nth-child(10)").html().replace("$ ","");
var footer_e=$(".jexcel > tfoot > tr > td:nth-child(12)").html().replace("$ ","");

   


      /* Highcharts.chart('container', {
            chart: {
                type: 'bar'
            },
            title: {
                text: 'Comparativas de costos'
            },
            xAxis: {
                categories: [$("#liquidacion-a option:selected").text(), ultimoMes, 'Proyectado'],
                labels: {
                formatter: function() {
                    return this.value.toLocaleString("es-ES");
                }
            }
            },
            yAxis: {
                title: {
                    text: 'Liquidaciones'
                }
            },
            series: [{
                name: 'Meses',
                data: [parseFloat(footer_c.replace(/[^0-9.-]/g, ''), 10), parseFloat(footer_b.replace(/[^0-9.-]/g, ''), 10), parseFloat(footer_a.replace(/[^0-9.-]/g, ''), 10)]
            }]
        });*/
    


         


})

        }

    },



};
</script>

<style scoped>




.load-box {
    background: red;
}


@keyframes placeHolderShimmer {
  0% {
    background-position: 0px 0;
  }
  100% {
    background-position: 100em 0;
  }
}


.load-box {
  animation-duration: 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: fff;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  height: 24px;
  -webkit-backface-visibility: hidden;
  left:0;
  right:0;
  top:0;
  bottom:0;
}

.up{
    color:green;
}
.down{
    color:red;
}

.colapse{
    position: absolute;
}

#sinreg{
    display: none;
}


.tablesorter tbody > tr > td > div[contenteditable=true]:focus {
  outline: #08f 1px solid;
  background: #eee;
  resize: none;
}
td.no-edit, span.no-edit {
  background-color: rgba(230,191,153,0.5);
}
.focused {
  color: blue;
}
td.editable_updated {
  background-color: green;
  color: white;
}




table {
  position: relative;
  border: 1px solid #ddd;
  border-collapse: collapse;
}

td, th {
  white-space: nowrap;
  border: 1px solid #ddd;
  padding: 20px;
  text-align: center;
}

th {
  background-color: #eee;
  position: sticky;
  top: -1px;
  z-index: 2;
  
  &:first-of-type {
    left: 0;
    z-index: 3;
  }
}

tbody tr td:first-of-type {
  background-color: #eee;
  position: sticky;
  left: -1px;
  text-align: left;
}

.card-ajustes{
  border: 1px solid #ececec;
  box-shadow: 0 6px 18px rgba(0,0,0,0.05);
}

.badge-ajuste-liquidacion{
  font-size: 12px;
  padding: 8px 12px;
}

.ajustes-table th,
.ajustes-table td{
  white-space: normal;
  padding: 12px;
}

.ajustes-table input{
  min-width: 110px;
}

.comentario {
  background-color: #FFD700; /* Cambia el color de fondo */
  color: #333; /* Cambia el color del texto */
  font-style: italic; /* Cambia el estilo de fuente a cursiva */
}







</style>